import { SignInWizardPage } from "../types";

const pageOrder: SignInWizardPage[] = ["Options", "Phone", "Verify", "Details"];

export const isValidNextWizardPage = (nextPage: SignInWizardPage, page?: SignInWizardPage) =>
    page ? pageOrder.indexOf(page) < pageOrder.indexOf(nextPage) : true;
